import { PIMCheckbox } from './PIMCheckbox';

export default PIMCheckbox;
